import { type FormEvent, useState } from 'react'
import { api, ApiFehler } from '../api'
import { fehlerText } from './gemeinsam'

export function Anmeldung({ onAngemeldet }: { onAngemeldet: () => void }) {
  const [benutzername, setBenutzername] = useState('')
  const [passwort, setPasswort] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [vergessen, setVergessen] = useState(false)
  const [resetGesendet, setResetGesendet] = useState(false)

  async function absenden(e: FormEvent) {
    e.preventDefault()
    setFehler(null)
    try {
      await api.anmelden(benutzername, passwort)
      onAngemeldet()
    } catch (err) {
      setFehler(err instanceof ApiFehler && err.status === 401 ? 'Benutzername oder Passwort falsch.' : String(err))
    }
  }

  async function resetAnfordern(e: FormEvent) {
    e.preventDefault()
    setFehler(null)
    try {
      await api.passwortVergessen(benutzername)
      setResetGesendet(true)
    } catch (err) {
      setFehler(fehlerText(err))
    }
  }

  function zurueck() {
    setVergessen(false)
    setResetGesendet(false)
    setFehler(null)
  }

  if (vergessen)
    return (
      <form className="anmeldung karte" onSubmit={resetAnfordern}>
        <h1>Dolly</h1>
        {resetGesendet ? (
          <p>Falls es den Benutzer gibt und eine bestätigte E-Mail-Adresse hinterlegt ist, ist ein Link zum Zurücksetzen unterwegs.</p>
        ) : (
          <>
            <p>Wir schicken dir einen Link an deine bestätigte E-Mail-Adresse.</p>
            <label>
              Benutzername
              <input autoComplete="username" value={benutzername} onChange={(e) => setBenutzername(e.target.value)} autoFocus />
            </label>
            {fehler && <p className="fehler">{fehler}</p>}
            <button type="submit" className="primaer" disabled={!benutzername}>
              Link anfordern
            </button>
          </>
        )}
        <button type="button" className="link" onClick={zurueck}>
          Zurück zur Anmeldung
        </button>
      </form>
    )

  return (
    <form className="anmeldung karte" onSubmit={absenden}>
      <h1>Dolly</h1>
      <label>
        Benutzername
        <input autoComplete="username" value={benutzername} onChange={(e) => setBenutzername(e.target.value)} autoFocus />
      </label>
      <label>
        Passwort
        <input type="password" autoComplete="current-password" value={passwort} onChange={(e) => setPasswort(e.target.value)} />
      </label>
      {fehler && <p className="fehler">{fehler}</p>}
      <button type="submit" className="primaer">
        Anmelden
      </button>
      <button type="button" className="link" onClick={() => setVergessen(true)}>
        Passwort vergessen?
      </button>
    </form>
  )
}
